var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSparklesSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.336 13.616c-4.676 1.575-6.218 3.33-7.358 7.7-1.14-4.369-2.68-6.124-7.357-7.7 4.676-1.575 6.217-3.33 7.357-7.7 1.14 4.37 2.682 6.124 7.358 7.7M22.137 6.326c-2.638.885-3.507 1.871-4.15 4.327-.643-2.456-1.513-3.44-4.15-4.327 2.637-.885 3.506-1.871 4.15-4.326.643 2.456 1.512 3.44 4.15 4.326M22.48 19.09c-1.953.64-2.597 1.355-3.072 3.134-.476-1.78-1.12-2.493-3.072-3.135 1.952-.64 2.596-1.355 3.072-3.135.475 1.78 1.12 2.494 3.071 3.135"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.336 13.616c-4.676 1.575-6.218 3.33-7.358 7.7-1.14-4.369-2.68-6.124-7.357-7.7 4.676-1.575 6.217-3.33 7.357-7.7 1.14 4.37 2.682 6.124 7.358 7.7M22.137 6.326c-2.638.885-3.507 1.871-4.15 4.327-.643-2.456-1.513-3.44-4.15-4.327 2.637-.885 3.506-1.871 4.15-4.326.643 2.456 1.512 3.44 4.15 4.326M22.48 19.09c-1.953.64-2.597 1.355-3.072 3.134-.476-1.78-1.12-2.493-3.072-3.135 1.952-.64 2.596-1.355 3.072-3.135.475 1.78 1.12 2.494 3.071 3.135"
  })));
});
export default SvgIconSparklesSolid;
export const raw = __webpack_public_path__ + "static/media/IconSparklesSolid.8b23964594d2646b4171515bbe1cadfa.svg";